const l = (e = "") => e ? String(e).replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, "").replace(/[^A-Za-z0-9]+/g, "$").replace(/([a-z])([A-Z])/g, (t, r, n) => `${r}$${n}`).toLowerCase().replace(/(\$)(\w)/g, (t, r, n) => n.toUpperCase()) : "", i = (e = "") => e ? String(e).replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, "").replace(/([a-z])([A-Z])/g, (t, r, n) => `${r}_${n.toLowerCase()}`).replace(/[^A-Za-z0-9]+|_+/g, "-").toLowerCase() : "", g = (e = "") => e ? String(e).replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, "$").replace(/[^A-Za-z0-9]+/g, "$").replace(/([a-z])([A-Z])/g, (t, r, n) => `${r}$${n}`).toLowerCase().replace(/(\$)(\w?)/g, (t, r, n) => n.toUpperCase()) : "", u = (e = "") => e ? String(e).replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, "").replace(/([a-z])([A-Z])/g, (t, r, n) => `${r}_${n.toLowerCase()}`).replace(/[^A-Za-z0-9]+|_+/g, "/").toLowerCase() : "", p = (e = "") => {
  if (!e)
    return "";
  const t = String(e).replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, "").replace(/([a-z])([A-Z])/g, (r, n, o) => `${n}_${o.toLowerCase()}`).replace(/[^A-Za-z0-9]+|_+/g, " ").toLowerCase();
  return t.charAt(0).toUpperCase() + t.slice(1);
}, f = (e = "") => e ? String(e).replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, "").replace(/([a-z])([A-Z])/g, (t, r, n) => r + "_" + n.toLowerCase()).replace(/[^A-Za-z0-9]+|_+/g, "_").toLowerCase() : "", $ = (e) => e == null ? void 0 : e.toLocaleString("en-US", { hour12: !1 }), s = (e, t, r = /* @__PURE__ */ new WeakMap()) => {
  if (Object.is(e, t))
    return !0;
  if (e instanceof Date && t instanceof Date)
    return e.getTime() === t.getTime();
  if (e instanceof RegExp && t instanceof RegExp)
    return e.toString() === t.toString();
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  if (r.get(e) === t)
    return !0;
  r.set(e, t);
  const n = Reflect.ownKeys(e), o = Reflect.ownKeys(t);
  if (n.length !== o.length)
    return !1;
  for (let a = 0; a < n.length; a++)
    if (!Reflect.has(t, n[a]) || !s(e[n[a]], t[n[a]], r))
      return !1;
  return !0;
}, z = (e) => {
  if (!e)
    return e;
  const t = e.replace(/[^\d]/g, ""), r = t.length;
  return r < 4 ? t : r < 7 ? `(${t.slice(0, 3)}) ${t.slice(3)}` : `(${t.slice(0, 3)}) ${t.slice(
    3,
    6
  )}-${t.slice(6, 10)}`;
}, Z = async () => {
  const e = await new Promise((t, r) => {
    navigator.geolocation.getCurrentPosition(t, r);
  });
  return {
    longitude: e.coords.longitude,
    latitude: e.coords.latitude
  };
}, c = (e, t) => e.test(t.toString()), m = (e) => c(/^[0-9]+(\.[0-9]{1,2})?$/, e), C = (e) => c(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, e), _ = (e) => c(/^\d{5}(?:[-\s]\d{4})?$/, e), w = (e, t) => {
  const { locale: r, currency: n } = t || {};
  return new Intl.NumberFormat(r || "en-US", {
    style: "currency",
    currency: n || "USD"
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  }).format(Number(e));
};
export {
  $ as convertToMilitaryTime,
  s as deepEqual,
  z as formatPhoneNumber,
  Z as geolocation,
  m as moneyRegEx,
  C as phoneNumberRegEx,
  _ as postalCodeRegEx,
  l as toCamelCase,
  i as toKebabCase,
  w as toMoneyString,
  g as toPascalCase,
  u as toPathCase,
  p as toSentenceCase,
  f as toSnakeCase
};
